<div *ngIf="(redirectToCase() | async)"></div>